import { Button } from '@material-ui/core'
import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { TextField, MenuItem, ButtonGroup } from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import './RegisterInterest.scss'
import { Fade } from 'react-reveal'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import countries from './countries.json'
import { CircularProgress } from '@material-ui/core'
import Swal from 'sweetalert2'
import useFetch from '../../../Hooks/useFetch'

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}))

export default function RegisterInterest({ projectNumber }) {
  const { data } = useFetch() // we can differentiate a/c to screen by passing props
  // console.log(data?.Registerinterest.title)
  const classes = useStyles()

  const [loading, setloading] = React.useState(false)

  const [currency, setCurrency] = React.useState('EUR')

  const handleChange = (event) => {
    setCurrency(event.target.value)
  }

  const handleSendEmail = (e) => {
    setloading(true)
    try {
      setTimeout(() => {
        setloading(false)
        Swal.fire(
          'Email Sent!',
          'Your email is sent with your detail',
          'success'
        )
      }, 2000)
    } catch (err) {
      console.error(err)
      setloading(false)
    }
  }

  return (
    <div id='register-interest'>
      <Container>
        <h1 className='text-white text-uppercase'>REGISTER YOUR INTEREST</h1>
        {/* <Fade right cascase> */}
        <Row className='grid-layout'>
          <Col lg={2}>
            {/* <input placeholder="NAME" /> */}
            <CssTextField
              id='outlined-basic'
              type='text'
              fullWidth
              label='Name'
              variant='outlined'
            />
          </Col>
          <Col lg={2}>
            {/* <input placeholder="EMAIL" /> */}
            <CssTextField
              id='outlined-basic'
              type='email'
              label='Email'
              variant='outlined'
              fullWidth
            />
          </Col>
          <Col lg={2}>
            {/* <input placeholder="PHONE NUMBER" /> */}
            <CssTextField
              id='outlined-basic'
              type='number'
              label='Phone number'
              fullWidth
              variant='outlined'
            />
          </Col>
          <Col lg={2}>
            {/* <input placeholder="CHOOSE COUNTRY" /> */}
            <CssTextField
              id='outlined-basic'
              label='Choose country'
              variant='outlined'
              value={currency}
              onChange={handleChange}
              fullWidth
              select
            >
              {countries.map((option) => (
                <MenuItem key={option.name} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </CssTextField>
          </Col>
          <Col lg={2}>
            {loading ? (
              <div className='d-flex justify-content-center mt-2'>
                <CircularProgress />
              </div>
            ) : (
              <ButtonGroup
                style={{
                  height: '3.5rem',
                  backgroundColor: '#656a77',
                  color: '#000',
                }}
                color='primary'
                fullWidth
                aria-label='outlined primary button group'
              >
                <Button style={{ width: '6vw' }}>
                  <div className='arrowwrap'>
                    <ArrowForwardIosIcon />
                  </div>
                </Button>
                <Button onClick={(e) => handleSendEmail(e)}>
                  <div className='registerButton'>Register</div>
                </Button>
              </ButtonGroup>
            )}{' '}
            {/* <Button variant="outlined" startIcon={<ArrowForwardIosIcon />}>
              <div className="arrowwrap">
                <ArrowForwardIosIcon />
              </div>
              <span>REGISTER</span>
            </Button> */}
          </Col>
        </Row>
        {/* </Fade> */}
      </Container>
    </div>
  )
}

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#fff',
    },

    '& .MuiSelect-select': {
      width: '10vw',
    },
    '& .MuiButtonGroup-root': {
      borderColor: '#fff',
    },
    '& .MuiSvgIcon-root': {
      color: '#fff',
    },
    '& #outlined-basic': {
      color: '#fff',
    },
    '& label.MuiInputLabel-root': {
      color: '#fff',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#656a77',
        color: '#fff',
      },
      '&:hover fieldset': {
        borderColor: '#fff',
        color: '#fff',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#fff',
        color: '#fff',
      },
    },
  },
})(TextField)
